function normalizeId(value) {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return String(value);
}

function cloneChildSelection(child, parentConfigurationId, childConfigurationId) {
	return {
		id: child?.id,
		parentId: parentConfigurationId,
		configurationId: childConfigurationId,
		enteredValue: child?.enteredValue || '',
	};
}

function cloneParentSelection(selection, option, children) {
	return {
		id: selection?.id,
		applicantId: selection?.applicantId,
		parentId: option?.id,
		configurationId: option?.id,
		children,
		enteredValue: selection?.enteredValue || '',
		isSingleSelection: option?.isSingleSelection,
	};
}

function findOptionById(options, configurationId) {
	const normalizedConfigurationId = normalizeId(configurationId);

	return Array.isArray(options)
		? options.find(option => normalizeId(option.id) === normalizedConfigurationId) || null
		: null;
}

function findSelectionIndexByConfigurationId(selections, configurationId) {
	const normalizedConfigurationId = normalizeId(configurationId);

	return selections.findIndex(selection => normalizeId(selection.configurationId) === normalizedConfigurationId);
}

function optionRequiresChildSelection(option) {
	return Array.isArray(option?.children) && option.children.length > 0;
}

function reconcileChildren(children, option) {
	if (!optionRequiresChildSelection(option)) {
		return [];
	}

	if (!Array.isArray(children)) {
		return [];
	}

	return children
		.map(child => {
			const childOption = findOptionById(option.children, child?.configurationId);

			return childOption ? cloneChildSelection(child, option.id, childOption.id) : null;
		})
		.filter(Boolean);
}

function reconcileParentSelections(selections, options) {
	if (!Array.isArray(selections) || !Array.isArray(options)) {
		return [];
	}

	return selections
		.map(selection => {
			const option = findOptionById(options, selection.configurationId);

			if (!option) {
				return null;
			}

			return cloneParentSelection(selection, option, reconcileChildren(selection.children, option));
		})
		.filter(Boolean);
}

function groupHasCurrentSelections(selections, options) {
	if (!Array.isArray(selections) || !Array.isArray(options) || selections.length === 0) {
		return false;
	}

	return selections.every(selection => findOptionById(options, selection.configurationId));
}

function reconcileDemographicSelections(options, demographic) {
	const safeDemographic = demographic || {};

	return {
		genders: reconcileParentSelections(safeDemographic.genders, options?.genders || []),
		ethnicGroups: reconcileParentSelections(safeDemographic.ethnicGroups, options?.ethnicGroups || []),
		races: reconcileParentSelections(safeDemographic.races, options?.races || []),
	};
}

function isDemographicSelectionComplete(options, demographic) {
	const reconciledDemographic = reconcileDemographicSelections(options, demographic);

	return groupHasCurrentSelections(reconciledDemographic.genders, options?.genders || [])
		&& groupHasCurrentSelections(reconciledDemographic.ethnicGroups, options?.ethnicGroups || [])
		&& groupHasCurrentSelections(reconciledDemographic.races, options?.races || []);
}

export {
	findSelectionIndexByConfigurationId,
	isDemographicSelectionComplete,
	normalizeId,
	optionRequiresChildSelection,
	reconcileDemographicSelections,
};

export default {
	findSelectionIndexByConfigurationId,
	isDemographicSelectionComplete,
	normalizeId,
	optionRequiresChildSelection,
	reconcileDemographicSelections,
};
